export enum CHARGER_STATUS {
    ONLINE = 'Online',
    OFFLINE = 'Offline',
}

export const ChargerStatus = [
    { value: CHARGER_STATUS.ONLINE, label: CHARGER_STATUS.ONLINE, check: false },
    { value: CHARGER_STATUS.OFFLINE, label: CHARGER_STATUS.OFFLINE, check: false },
]